var _path, _path2, _path3, _path4, _rect, _path5, _rect2, _path6, _path7, _path8, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08688 13L-0.000244141 32L-0.000124514 39H55.9997V32L49.913 13H6.08688Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C10 2.89543 10.8954 2 12 2H44C45.1046 2 46 2.89543 46 4V33H10V4Z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22C7 20.8954 7.89543 20 9 20H47C48.1046 20 49 20.8954 49 22V42H7V22Z",
    fill: "#EFEFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.803 8.19691C31.5404 7.93436 31.1147 7.93436 30.8522 8.19691L28.0002 11.0489L25.1484 8.19708C24.8859 7.93454 24.4602 7.93454 24.1977 8.19708C23.9351 8.45963 23.9351 8.8853 24.1977 9.14785L27.0495 11.9997L24.1969 14.8523C23.9344 15.1148 23.9344 15.5405 24.1969 15.803C24.4595 16.0656 24.8851 16.0656 25.1477 15.803L28.0002 12.9504L30.853 15.8032C31.1155 16.0657 31.5412 16.0657 31.8037 15.8032C32.0663 15.5406 32.0663 15.115 31.8037 14.8524L28.951 11.9997L31.803 9.14767C32.0655 8.88513 32.0655 8.45946 31.803 8.19691Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 42,
    height: 3,
    fill: "url(#paint0_linear_8469_6354)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28C5 26.8954 5.89543 26 7 26H49C50.1046 26 51 26.8954 51 28V43H5V28Z",
    fill: "#EFEFEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 31,
    width: 46,
    height: 7,
    fill: "url(#paint1_linear_8469_6354)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 32.0002H13.0003C14.2177 32.0002 16.5 32.0002 17.0433 34.2859L18 37.9999H38L38.9563 34.2859C39.5 32.0002 41.7826 32.0002 43 32.0002V32H56V54C56 55.1046 55.1046 56 54 56H2C0.89543 56 0 55.1046 0 54V32H13V32.0002Z",
    fill: "#D2D2D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46C19 45.4477 19.4477 45 20 45V45C20.5523 45 21 45.4477 21 46V48H19V46Z",
    fill: "#EFEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35 46C35 45.4477 35.4477 45 36 45V45C36.5523 45 37 45.4477 37 46V48H35V46Z",
    fill: "#EFEFEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 47,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#EFEFEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8469_6354",
    x1: 28,
    y1: 32.25,
    x2: 28,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8469_6354",
    x1: 28,
    y1: 52.5833,
    x2: 28,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/EmptyBox.91d1cf104735a352497a315491f23b8c.svg";
export { ForwardRef as ReactComponent };